/* import __COLOCATED_TEMPLATE__ from './po-payload.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';

interface TasksKitListPoPayloadSignature {
  Args: {
    id: unknown;
    payload: unknown;
  };
  Element: HTMLElement;
}

const TasksKitListPoPayloadComponent = templateOnlyComponent<TasksKitListPoPayloadSignature>();

export default TasksKitListPoPayloadComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'TasksKit::List::PoPayload': typeof TasksKitListPoPayloadComponent;
    'tasks-kit/list/po-payload': typeof TasksKitListPoPayloadComponent;
  }
}
